<div class="mat-card card">
  <div class="row">
    <div class="col-8">
      <h2 class="main-heading">
        Manage Departments
      </h2>
    </div>
    <div class="col-4">
      <button mat-button class="submit" (click)="startCreating()">Add Department</button>
    </div>
  </div>

  <!-- Inline creation form -->
  <div *ngIf="isCreatingNew" class="creation-form mat-elevation-z8">
    <div class="row">
      <div class="col-5">
        <input type="text" class="form-input" [(ngModel)]="newDepartment.name" placeholder="Department Name">
      </div>
      <div class="col-5">
        <input type="text" class="form-input" [(ngModel)]="newDepartment.description" placeholder="Description">
      </div>
      <div class="col-2 action-buttons">
        <button mat-button class="submit" (click)="createDepartment()">Save</button>
        <button mat-button class="cancel" (click)="cancelCreating()">Cancel</button>
      </div>
    </div>
  </div>

  <div class="matTableDiv">
    <table mat-table matSort [dataSource]="dataSource" class="mat-elevation-z8">
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Name </th>
        <td mat-cell *matCellDef="let element" id="name">
          <ng-container *ngIf="isEditingId !== element._id; else editName">
            <ng-container *ngIf="element.name == undefined || element.name == '';else Name">NA</ng-container>
            <ng-template #Name>{{element.name}}</ng-template>
          </ng-container>
          <ng-template #editName>
            <input type="text" class="form-input edit-input" [(ngModel)]="editDepartmentData.name">
          </ng-template>
        </td>
      </ng-container>

      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Description </th>
        <td mat-cell *matCellDef="let element" id="description">
          <ng-container *ngIf="isEditingId !== element._id; else editDescription">
            <ng-container *ngIf="element.description == undefined || element.description == '';else Description">NA</ng-container>
            <ng-template #Description>{{element.description}}</ng-template>
          </ng-container>
          <ng-template #editDescription>
            <input type="text" class="form-input edit-input" [(ngModel)]="editDepartmentData.description">
          </ng-template>
        </td>
      </ng-container>

      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef>Action</th>
        <td mat-cell *matCellDef="let element">
            <ng-container *ngIf="isEditingId !== element._id; else saveCancel">
            <!-- Edit SVG Icon -->
            <svg class="icon" (click)="startEditing(element)" title="Edit" viewBox="0 0 24 24">
                <path fill="currentColor" d="M20.71,7.04C21.1,6.65 21.1,6 20.71,5.63L18.37,3.29C18,2.9 17.35,2.9 16.96,3.29L15.12,5.12L18.87,8.87M3,17.25V21H6.75L17.81,9.93L14.06,6.18L3,17.25Z"/>
            </svg>
            
            <!-- Delete SVG Icon -->
            <svg class="icon" (click)="deleteDepartment(element._id)" title="Delete" viewBox="0 0 24 24">
                <path fill="currentColor" d="M19,4H15.5L14.5,3H9.5L8.5,4H5V6H19M6,19A2,2 0 0,0 8,21H16A2,2 0 0,0 18,19V7H6V19Z"/>
            </svg>
            </ng-container>
            <ng-template #saveCancel>
            <!-- Save SVG Icon -->
            <svg class="icon" (click)="updateDepartment(element._id)" title="Save" viewBox="0 0 24 24">
                <path fill="currentColor" d="M15,9H5V5H15M12,19A3,3 0 0,1 9,16A3,3 0 0,1 12,13A3,3 0 0,1 15,16A3,3 0 0,1 12,19M17,3H5C3.89,3 3,3.9 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V7L17,3Z"/>
            </svg>
            
            <!-- Cancel SVG Icon -->
            <svg class="icon" (click)="cancelEditing()" title="Cancel" viewBox="0 0 24 24">
                <path fill="currentColor" d="M12,2C17.53,2 22,6.47 22,12C22,17.53 17.53,22 12,22C6.47,22 2,17.53 2,12C2,6.47 6.47,2 12,2M15.59,7L12,10.59L8.41,7L7,8.41L10.59,12L7,15.59L8.41,17L12,13.41L15.59,17L17,15.59L13.41,12L17,8.41L15.59,7Z"/>
            </svg>
            </ng-template>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr class="data" mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

    <mat-paginator [length]="length" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions" (page)="pageEvent = $event">
    </mat-paginator>
  </div>
</div>